/**
 * Reminders sent from this device today, so the Team tab can show "Sent to Sam at 9:10". The API has no list route for
 * reminders yet, so this is a local log, labeled as such on screen (never presented as the org-wide record).
 */
import { useSyncExternalStore } from "react";

export interface SentReminder { to: string; message: string; at: string }
let list: SentReminder[] = [];
const subs = new Set<() => void>();

export function logReminder(r: SentReminder) {
  const today = new Date().toDateString();
  list = [r, ...list.filter((x) => new Date(x.at).toDateString() === today)].slice(0, 30);
  subs.forEach((f) => f());
}

export function useRemindersSent(): SentReminder[] {
  return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => list, () => list);
}
